<template>
  <div class="privacy-icon mb-4">
    <i class="fas fa-shield-alt"></i>
  </div>
</template>

<script>
export default {
  name: 'PrivacyIcon'
}
</script>

<style scoped>
.privacy-icon {
  animation: fadeInDown 0.8s ease-out;
}

.privacy-icon i {
  font-size: 4rem;
  color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.15);
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 3px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .privacy-icon i {
    font-size: 3rem;
    width: 80px;
    height: 80px;
  }
}
</style>

